import React from 'react';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import TopBanner from '../components/TopBanner';

export default function PageNotFound() {

  const errorimg = '/images/404.jpg';
  const server_url = process.env.REACT_APP_SERVER;

  return (
    <HelmetProvider>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <meta name="description" content="404 Error - Page not found." />
        <meta name="author" content="Lurantech" />
        <title>404 Error | Lurantech</title>

        <link rel="preload" href={`${server_url}${errorimg}`} as="image" />
      </Helmet>

      <TopBanner bgimage={errorimg} title="404 - No such page exists" />
    </HelmetProvider>
  );
}
